import { render, staticRenderFns } from "./RadioItem.vue?vue&type=template&id=0f37ffa3&"
import script from "./RadioItem.vue?vue&type=script&lang=ts&"
export * from "./RadioItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/sush/Virtual/cublic-form-api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f37ffa3')) {
      api.createRecord('0f37ffa3', component.options)
    } else {
      api.reload('0f37ffa3', component.options)
    }
    module.hot.accept("./RadioItem.vue?vue&type=template&id=0f37ffa3&", function () {
      api.rerender('0f37ffa3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resource/component/form/Field/RadioItem.vue"
export default component.exports